import { useEffect } from 'react';

/**
 * Inject a JSON-LD <script type="application/ld+json"> block into <head>.
 * Removes the block on unmount so SPA route changes do not leave stale schema.
 *
 * @param {string} id   Stable identifier (becomes id="jsonld-<id>").
 * @param {object} data JSON-LD payload (object, not stringified).
 */
const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node && node.parentNode) node.parentNode.removeChild(node);
    };
  }, [id, data]);
};

export default useJsonLd;
